/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState, useEffect, useRef, Suspense, useCallback, useContext, KeyboardEvent } from "react";
import { useDebouncedCallback } from "use-debounce";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import {
	TextField,
	Checkbox,
	CheckboxProps,
	withStyles,
	Paper,
	Grid,
	Button,
	Select,
	MenuItem
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { green } from "@material-ui/core/colors";
import { SnackbarProps } from "../../../../../@types/snackbarAPI.types";
import { AuthContext, UIContext } from "../../../../../contexts";
import { Validation } from "../../../../../@types/validation.types";
import { DynamicForm, DynamicFormField } from "../../../../../@types/dynamicForm.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import validateEmail from "../../../../../utils/commonFunctions/validateEmail";
import { LazySnackbarAPI } from "../../../../shared";
import { api } from "../../../../../utils/api";
import initCapitalize from "../../../../../utils/commonFunctions/initCapitalize";
import STATES from "../../../../../constants/states";
import ROLES from "../../../../../constants/roles";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";

import PersonAddIcon from "@material-ui/icons/PersonAdd";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import EventIcon from "@material-ui/icons/Event";

import "../../../../../globalStyles/paperFormStyles.css";
import GENDERS from "../../../../../constants/genders";
import { MARITAL_STATUSES } from "../../../../../constants/maritalStatus";
import CONTACT_LABELS from "../../../../../constants/contactLabels";
import { useEmployerRoute } from "../../../../../hooks";
import { type } from "os";

const mailformat = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;
const specialCharacters = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const CreateGroupOwner = () => {
	const [userForm, setUserForm] = useState<DynamicForm>();
	const [emailExists, setEmailExists] = useState(false);
	const isEmployerRoute = useEmployerRoute();
	const [checkInvalidEmail, setCheckInvalidEmail] = useState(false);
	const [pasted, setPasted] = useState(false);
	const [hasCreateClick, setHasCreateClick] = useState(false);
	const [assignedGroups, setAssignedGroups] = useState<any[]>([]);
	const [selectedGroup, setSelectedGroup] = useState({});
	const { user } = useContext(AuthContext); // Extracting logged in user from central storage.
	const [createGroupOwner, setCreateGroupOwner] = useState<any>({
		first_name: "",
		middle_name: "",
		last_name: "",
		role: "",
		type: "",
		writing_number: null,
		email: "",
		SSN: "",
		date_of_birth: "",
		gender: null,
		marital_status: null,
		address_line_1: "",
		address_line_2: "",
		city: "",
		state: "",
		country: "USA - United States of America",
		ZIP: "",
		contact_label: null,
		phone_extension: null,
		phone_number: null,
		is_member_chat_support: false,
		is_employer_chat_support: false,
		hire_date: "",
		group_number: null
	});
	const [reEnterSSN, setReEnterSSN] = useState("");
	const [validation, setValidation] = useState<Validation>({
		createGroupOwner: {},
		reEnterSSN: "",
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	const navigate = useNavigate();
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const { setDashboardHeader } = useContext(UIContext);

	const getAssignGroups = useCallback(async () => {
		const params = {
			user_id: user?._id
		};
		const response = await api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params);

		if (response) {
			const _assignedGroups: any[] = [];
			response.groupsAndLocations.forEach((group: any) => {
				if (group.assigned_group_info) {
					_assignedGroups.push(group);
				}
			});

			setAssignedGroups(Object.assign([], _assignedGroups));
		}
	}, [user?._id]);

	const findGroupOwnerEmail = useDebouncedCallback(async (value: string) => {
		if (value !== "") {
			const email = await api.find.findGroupOwnerEmail(value);
			if (email === false) {
				setEmailExists(false);
			} else {
				setEmailExists(true);
			}
		} else {
			setEmailExists(false);
		}
	}, 500);

	const handleValidation = useCallback(async () => {
		const {
			group_number,
			first_name,
			last_name,
			role,
			type,
			writing_number,
			SSN,
			date_of_birth,
			hire_date,
			email,
			ZIP
		} = createGroupOwner;
		_validation.current = {
			...validation,
			createGroupOwner: {},
			reEnterSSN: "",
			status: "invalid"
		};
		let flag = true;

		// createGroupOwner validation checking + ReEnter SSN Validation Checking
		if (first_name.length === 0) {
			_validation.current.createGroupOwner["first_name"] = "First Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (last_name.length === 0) {
			_validation.current.createGroupOwner["last_name"] = "Last Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (role.length === 0) {
			_validation.current.createGroupOwner["role"] = "Role is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (role === "ENROLLER") {
			if (type.length === 0) {
				_validation.current.createGroupOwner["type"] = "Role Type is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}

			if (writing_number.length === 0) {
				_validation.current.createGroupOwner["writing_number"] = "Writing Number is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (role === ROLES.employer) {
			if (group_number === null) {
				_validation.current.createGroupOwner["group_number"] = "Group Number is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (email.length === 0) {
			_validation.current.createGroupOwner["email"] = "Email is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (email.length !== 0) {
			if (!email.match(mailformat)) {
				_validation.current.createGroupOwner["email"] = "Valid Email is required";
				_validation.current["status"] = "invalid";
				flag = false;
			}
			setCheckInvalidEmail(false);
			if (!validateEmail(email)) {
				setCheckInvalidEmail(true);
			}
		}
		if (SSN !== "") {
			const _SSN = SSN.replaceAll("-", "");
			if (String(_SSN).length !== 9) {
				_validation.current.createGroupOwner["SSN"] = "Enter correct 9 digit SSN";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (SSN !== "") {
			if (reEnterSSN === "") {
				_validation.current["reEnterSSN"] = "Re-Enter SSN cannot be Empty, as SSN is Given";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (SSN !== "") {
			const _SSN = SSN.replaceAll("-", "");
			const _reEnterSSN = reEnterSSN.replaceAll("-", "");
			if (_SSN !== _reEnterSSN) {
				_validation.current["reEnterSSN"] = "Must be same as SSN";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		if (reEnterSSN !== "") {
			if (SSN === "") {
				_validation.current.createGroupOwner["SSN"] = "SSN cannot be Empty, as Re-Enter SSN is Given";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}
		// if (hire_date.length !== 0) {
		// 	if (date_of_birth.length === 0) {
		// 		_validation.current.createGroupOwner["date_of_birth"] = "Date of birth is required";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		// if (hire_date.length !== 0) {
		// 	const hireDate = new Date(hire_date).getFullYear();
		// 	const DOB = new Date(date_of_birth).getFullYear();
		// 	const hireDateTime = new Date(hire_date).getTime();
		// 	const DOBtime = new Date(date_of_birth).getTime();
		// 	const age = hireDate - DOB;
		// 	if (age <= 14) {
		// 		_validation.current.createGroupOwner["hire_date"] = "Age should be 14 years or above!";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// 	if (hireDateTime < DOBtime) {
		// 		_validation.current.createGroupOwner["hire_date"] = "Hire date cannot be less than Date of Birth!";
		// 		_validation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }
		if (ZIP.length !== 0) {
			const _zip = ZIP.replaceAll("-", "");
			if (_zip.length !== 5 && _zip.length !== 9) {
				_validation.current.createGroupOwner["ZIP"] = "Enter 5 or 9 digit ZIP Code!";
				_validation.current["status"] = "invalid";
				flag = false;
			}
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [createGroupOwner, reEnterSSN, validation]);

	const handleKeyCheck = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const { name } = event.target as HTMLInputElement;
			let { value } = event.target as HTMLInputElement;
			const eventKey = event.key;

			if (name === "ZIP") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
					}
				}
			}
			if (name === "SSN") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 4) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
					}
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.lastIndexOf("-");
						value = value.substring(0, index);
						setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
					}
				}
			}
			if (name === "re_enter_SSN") {
				if (eventKey === "Backspace" || eventKey === "Delete") {
					if (/[-]/.test(value) && value.length === 4) {
						event.preventDefault();
						const index = value.indexOf("-");
						value = value.substring(0, index);
						setReEnterSSN(value);
					}
					if (/[-]/.test(value) && value.length === 7) {
						event.preventDefault();
						const index = value.lastIndexOf("-");
						value = value.substring(0, index);
						setReEnterSSN(value);
					}
				}
			}
		},
		[createGroupOwner]
	);

	const handlePaste = (event: React.ClipboardEvent<HTMLInputElement | HTMLDivElement>) => {
		const { name } = event.target as HTMLInputElement;
		if (name === "SSN" || name === "ZIP" || name === "re_enter_SSN") {
			setPasted(true);
			setTimeout(() => null, 2000);
		}
	};

	const handleHyphenInZip = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "-") {
			event.preventDefault();
		}
	};
	// const handleReEnterSSNChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
	// 	const { value } = event.target;
	// 	setReEnterSSN(value);
	// }, []);

	const handleReEnterSSNChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			let { value } = event.target;

			if (!pasted) {
				const _value = Number(value.replaceAll("-", ""));
				if (!isNaN(_value as any)) {
					let ssn = value;
					if (
						!(
							/^[0-9]{0,3}$/.test(value) ||
							/^[0-9]{3}-[0-9]{0,2}$/.test(value) ||
							/^[0-9]{3}-[0-9]{2}-[0-9]{0,4}$/.test(value)
						)
					) {
						// value = value.substr(0, ssn.length - 1);
						ssn = ssn.substring(0, ssn.length - 1);
					} else if (ssn.length === 6) {
						ssn = ssn.substring(0, 7) + "-" + ssn.substring(7);
					} else if (ssn.length === 3) {
						// value = value.substr(0, 3) + "-" + value.substr(3);
						ssn = ssn.substring(0, 3) + "-" + ssn.substring(3);
					}
					setReEnterSSN(ssn);
				} else {
					event.target.value = "";
					event.target.value = reEnterSSN;
				}
			} else {
				// console.log("Pasted");
				setPasted(false);
				if (!isNaN(value as any)) {
					if (value.length > 9) {
						event.target.value = "";
						event.target.value = reEnterSSN;
						alert("Please enter a valid 9 digit SSN!");
					} else {
						// console.log("Inside Number");
						const ssn = value;

						if (ssn.length === 4) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						} else if (ssn.length === 5) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						} else if (ssn.length >= 6 && ssn.length <= 9) {
							value = value.substring(0, 3) + "-" + value.substring(3, 2) + "-" + value.substring(5);
						}
						setReEnterSSN(value);
					}
				} else {
					// console.log("Inside alpha-numeric");
					let ssnValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
					//console.log("replaced string", ssnValue);
					alert("You have pasted alpha-numeric SSN!");

					if (ssnValue.length > 9) {
						event.target.value = "";
						event.target.value = reEnterSSN as unknown as string;
						alert("Please enter a valid SSN!");
					} else {
						const ssn = ssnValue;

						if (ssn.length === 4) {
							ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
						} else if (ssn.length === 5) {
							ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
						} else if (ssn.length >= 6 && ssn.length <= 9) {
							ssnValue =
								ssnValue.substring(0, 3) + "-" + ssnValue.substring(3, 2) + "-" + ssnValue.substr(5);
						}

						setReEnterSSN(ssnValue);
					}
				}
			}
		},
		[pasted, reEnterSSN]
	);

	const handleGroupOwnerChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			let { value } = event.target;
			const { name } = event.target;
			if (name === "first_name") {
				const regex = /^[a-zA-Z]+$/;
				if (value.match(regex) || value === "") {
					value = value.slice(0, 1).toUpperCase() + value.slice(1);
					setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
				} else if (/\s/g.test(value)) {
					setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
				}
			} else if (name === "role") {
				createGroupOwner.group_number = null;
				createGroupOwner.is_employer_chat_support = false;
				createGroupOwner.type = "";
				createGroupOwner.writing_number = "";
				setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value.toUpperCase() }));
			} else if (name === "type") {
				// createGroupOwner.type = "";
				setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value.toUpperCase() }));
			} else if (name === "email") {
				findGroupOwnerEmail(value);
				setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
			} else if (name === "SSN") {
				if (!pasted) {
					// console.log("Not Pasted");
					const _value = value.replaceAll("-", "");
					if (!isNaN(_value as any)) {
						const ssn = value;
						if (
							!(
								/^[0-9]{0,3}$/.test(value) ||
								/^[0-9]{3}-[0-9]{0,2}$/.test(value) ||
								/^[0-9]{3}-[0-9]{2}-[0-9]{0,4}$/.test(value)
							)
						) {
							value = value.substring(0, value.length - 1);
						} else if (ssn.length === 6) {
							value = value.substring(0, 7) + "-" + value.substring(7);
						} else if (ssn.length === 3) {
							value = value.substring(0, 3) + "-" + value.substring(3);
						}

						setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
					} else {
						event.target.value = "";
						event.target.value = createGroupOwner.SSN;
					}
				} else {
					// console.log("Pasted");
					setPasted(false);
					if (!isNaN(value as any)) {
						if (value.length > 9) {
							event.target.value = "";
							event.target.value = createGroupOwner.SSN;
							alert("Please enter a valid 9 digit SSN!");
						} else {
							// console.log("Inside Number");
							const ssn = value;

							if (ssn.length === 4) {
								value = value.substring(0, 3) + "-" + value.substring(3);
							} else if (ssn.length === 5) {
								value = value.substring(0, 3) + "-" + value.substring(3);
							} else if (ssn.length >= 6 && ssn.length <= 9) {
								value = value.substring(0, 3) + "-" + value.substring(3, 2) + "-" + value.substring(5);
							}

							setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						let ssnValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
						//console.log("replaced string", ssnValue);
						alert("You have pasted alpha-numeric SSN!");

						if (ssnValue.length > 9) {
							event.target.value = "";
							event.target.value = createGroupOwner.SSN;
							alert("Please enter a valid SSN!");
						} else {
							const ssn = ssnValue;

							if (ssn.length === 4) {
								ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
							} else if (ssn.length === 5) {
								ssnValue = ssnValue.substring(0, 3) + "-" + ssnValue.substring(3);
							} else if (ssn.length >= 6 && ssn.length <= 9) {
								ssnValue =
									ssnValue.substring(0, 3) +
									"-" +
									ssnValue.substring(3, 2) +
									"-" +
									ssnValue.substring(5);
							}

							setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: ssnValue }));
						}
					}
				}
			} else if (name === "ZIP") {
				if (!pasted) {
					const _value = value.replaceAll("-", "");
					if (!isNaN(_value as any) && value.length <= 10) {
						const zip = value;
						if (zip.length === 6) {
							value = value.substring(0, 5) + "-" + value.substring(5);
						}

						// console.log("ZIP Event", event.target.value);
						setCreateGroupOwner(
							Object.assign({}, createGroupOwner, {
								[name]: value
							})
						);
					} else {
						event.target.value = "";
						event.target.value = createGroupOwner.ZIP;
					}
				} else {
					setPasted(false);
					if (!isNaN(value as any)) {
						if (value.length > 9) {
							event.target.value = "";
							event.target.value = createGroupOwner.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							// console.log("Inside Number");
							const zip = value;

							if (zip.length >= 6 && zip.length <= 9) {
								value = value.substring(0, 5) + "-" + value.substring(5);
							}

							setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
						}
					} else {
						// console.log("Inside alpha-numeric");
						let zipValue = value.replace(/[^0-9]/g, "").replace(/[^\w\s]/gi, "");
						//console.log("replaced string", zipValue);
						alert("You have pasted alpha-numeric ZIP!");

						if (zipValue.length > 9) {
							event.target.value = "";
							event.target.value = createGroupOwner.ZIP;
							alert("Please enter a valid 5 or 9 digit ZIP!");
						} else {
							const zip = zipValue;

							if (zip.length >= 6 && zip.length <= 9) {
								zipValue = zipValue.substring(0, 5) + "-" + zipValue.substring(5);
							}

							setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: zipValue }));
						}
					}
				}
			} else if (name === "phone_number") {
				if (!isNaN(value as any)) {
					if (value.length <= 10) {
						setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
					} else {
						event.target.value = createGroupOwner?.phone_number
							? (createGroupOwner?.phone_number as unknown as string)
							: "";
						alert("Phone Number cannot be greater 10 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = createGroupOwner?.phone_number
						? (createGroupOwner?.phone_number as unknown as string)
						: "";
				}
			} else if (name === "phone_extension") {
				if (!isNaN(value as any)) {
					if (value.length <= 3) {
						setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
					} else {
						event.target.value = createGroupOwner?.phone_extension
							? (createGroupOwner?.phone_extension as unknown as string)
							: "";
						alert("Phone Extension cannot be greater 3 digit!");
					}
				} else {
					event.target.value = "";
					event.target.value = createGroupOwner?.phone_extension
						? (createGroupOwner?.phone_extension as unknown as string)
						: "";
				}
			} else if (name === "writing_number") {
				if (!isNaN(value as any)) {
					setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value.trim() }));
				} else {
					event.target.value = "";
					event.target.value = createGroupOwner?.writing_number
						? (createGroupOwner?.writing_number as unknown as any)
						: "";
				}
			} else {
				setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: value }));
			}
		},
		[createGroupOwner, findGroupOwnerEmail, pasted]
	);

	const handleGroupOwnerDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const date = new Date(_date as any);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

			setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: parsedDate }));
		},
		[createGroupOwner]
	);

	const handleEnableCheckbox = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, checked } = event.target;
			setCreateGroupOwner(Object.assign({}, createGroupOwner, { [name]: checked }));
		},
		[createGroupOwner]
	);

	const handleGroupChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target;

			setCreateGroupOwner(
				Object.assign({}, createGroupOwner, {
					group_number: value
				})
			);

			// Storing and Checking of Particular group for all locations of that group.
			assignedGroups.forEach((group: any) => {
				if (group.group_number === value) {
					setSelectedGroup(Object.assign({}, group));
				}
			});
		},
		[assignedGroups, createGroupOwner]
	);

	const handleUserManagementNavigation = useCallback(() => {
		const pathname = "/settings/user-management";
		navigate(pathname);
	}, [navigate]);

	const handleCreateGroupOwner = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const validation = await handleValidation();
				if (validation === "valid") {
					const { date_of_birth, hire_date, writing_number, type } = createGroupOwner;
					const DOB = date_of_birth ? new Date(date_of_birth) : null;
					const hireDate = hire_date ? new Date(hire_date) : null;

					const payload = {
						...createGroupOwner,
						role: createGroupOwner.role,
						type: type ? type : null,
						writing_number: Number(writing_number as number),
						date_of_birth:
							DOB !== null ? DOB.getFullYear() + "-" + (DOB.getMonth() + 1) + "-" + DOB.getDate() : DOB,
						hire_date:
							hireDate !== null
								? hireDate.getFullYear() + "-" + (hireDate.getMonth() + 1) + "-" + hireDate.getDate()
								: hireDate,
						SSN: createGroupOwner.SSN ? createGroupOwner?.SSN?.replaceAll("-", "") : "",
						ZIP: createGroupOwner.ZIP ? createGroupOwner.ZIP.replaceAll("-", "") : ""
					};

					//console.log("Payload", payload);
					const response = await trackPromise(api.auth.createGroupOwner(payload));

					if (response) {
						setHasCreateClick(true);
						// console.log("Response", response);
						setCreateGroupOwner(Object.assign({}, response as any));
						// alert("Group Owner Creation Successfully!");
						setSnackbarAPICallProps(
							Object.assign({}, snackbarAPICallProps, {
								open: true,
								message: "User Created Successfully!",
								severity: "success"
							})
						);

						setTimeout(() => {
							handleUserManagementNavigation();
						}, 2000);
					}
				} else {
					setHasCreateClick(false);
				}
			} catch (error) {
				setHasCreateClick(false);
				alert("Group Owner Creation unsuccessful!");
				throw error;
			}
		},
		[createGroupOwner, handleUserManagementNavigation, handleValidation, snackbarAPICallProps]
	);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.create_user);
		getAssignGroups();
	}, [getAssignGroups, setDashboardHeader]);

	useEffect(() => {
		const _userForm = Object.assign(
			{},
			{
				"Role Information": [
					{
						label: "Role",
						name: "role",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Select role",
						value: createGroupOwner.role,
						type: "select",
						options:
							user?.role === ROLES.super_admin
								? [
										initCapitalize(ROLES.admin),
										initCapitalize(ROLES.employer),
										initCapitalize("ENROLLER")
								  ]
								: [initCapitalize(ROLES.employer), initCapitalize("ENROLLER")]
					}
				],
				"Group Information": [
					{
						label: "Group",
						name: "group_number",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
							if (createGroupOwner.role === "") {
								event.target.value = "";
								alert("Please select Role first!");
								// console.log("Event", event);
								return;
							} else {
								handleGroupChange(event);
							}
						},
						//placeholder: "Select group",
						value: createGroupOwner.group_number,
						type: "select",
						options: [...assignedGroups]
					}
				],
				"Group Owner Information": [
					{
						label: "First Name",
						name: "first_name",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter first name",
						value: createGroupOwner.first_name,
						type: "textfield",
						controlled: false
					},
					{
						label: "Middle Name",
						name: "middle_name",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter middle name",
						value: createGroupOwner.middle_name,
						type: "textfield",
						controlled: false
					},
					{
						label: "Last Name",
						name: "last_name",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter last name",
						value: createGroupOwner.last_name,
						type: "textfield",
						controlled: false
					},
					{
						label: "Email",
						name: "email",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter email",
						value: createGroupOwner.email,
						type: "textfield",
						controlled: false
					},
					{
						label: "SSN",
						name: "SSN",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter SSN",
						value: createGroupOwner.SSN,
						type: "textfield"
					},
					{
						label: "Re-Enter SSN",
						name: "re_enter_SSN",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleReEnterSSNChange(event),
						placeholder: "Re-Enter SSN",
						value: reEnterSSN,
						type: "textfield"
					},
					{
						label: "Date of Birth",
						name: "date_of_birth",
						onChange: (date: MaterialUiPickersDate, name: string) => handleGroupOwnerDateChange(date, name),
						placeholder: "Enter date of birth",
						value: createGroupOwner.date_of_birth,
						type: "date"
					},
					{
						label: "Hire Date",
						name: "hire_date",
						onChange: (date: MaterialUiPickersDate, name: string) => handleGroupOwnerDateChange(date, name),
						placeholder: "Enter hire date",
						value: createGroupOwner.hire_date,
						type: "date"
					},
					{
						label: "Gender",
						name: "gender",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter gender",
						value: createGroupOwner.gender,
						type: "select",
						options: GENDERS
					},
					{
						label: "Marital Status",
						name: "marital_status",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter marital status",
						value: createGroupOwner.marital_status,
						type: "select",
						options: MARITAL_STATUSES
					},
					{
						label: "Member Chat Support",
						name: "is_member_chat_support",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
						value: createGroupOwner.is_member_chat_support,
						type: "checkbox"
					},
					{
						label: "Employer Chat Support",
						name: "is_employer_chat_support",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
						value: createGroupOwner.is_employer_chat_support,
						type: "checkbox"
					}
				],
				"Group Owner Contact Details": [
					{
						label: "Contact Label",
						name: "contact_label",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter contact label",
						value: createGroupOwner.contact_label,
						type: "select",
						options: CONTACT_LABELS
					},
					{
						label: "Phone Number",
						name: "phone_number",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter phone number",
						value: createGroupOwner.phone_number,
						type: "textfield",
						controlled: false
					},
					{
						label: "Phone Extension",
						name: "phone_extension",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter phone extension",
						value: createGroupOwner.phone_extension,
						type: "textfield",
						controlled: false
					}
				],
				"Group Owner Address": [
					{
						label: "Address Line 1",
						name: "address_line_1",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter address line 1",
						value: createGroupOwner.address_line_1,
						type: "textfield",
						controlled: false
					},
					{
						label: "Address Line 2",
						name: "address_line_2",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter address line 2",
						value: createGroupOwner.address_line_2,
						type: "textfield",
						controlled: false
					},
					{
						label: "City",
						name: "city",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter city",
						value: createGroupOwner.city,
						type: "textfield",
						controlled: false
					},
					{
						label: "State",
						name: "state",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter state",
						value: createGroupOwner.state,
						type: "select",
						options: STATES
					},
					{
						label: "Country",
						name: "country",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter country",
						value: "USA - United States of America",
						type: "textfield"
					},
					{
						label: "ZIP Code",
						name: "ZIP",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter ZIP",
						value: createGroupOwner.ZIP,
						type: "textfield"
					}
				]
			}
		);
		if (createGroupOwner.role !== "ENROLLER") {
			setUserForm(Object.assign({}, _userForm));
		} else {
			const newUserForm = {
				..._userForm,
				"Role Information": [
					..._userForm["Role Information"],
					{
						label: "Type",
						name: "type",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Select type",
						value: createGroupOwner.type,
						type: "select",
						options: [initCapitalize("ENROLLER ADMIN"), initCapitalize("AGENT")]
					},
					{
						label: "Writing Number",
						name: "writing_number",
						onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleGroupOwnerChange(event),
						placeholder: "Enter Writing Number",
						value: createGroupOwner.writing_number,
						type: "textfield"
					}
				]
			};
			setUserForm(Object.assign({}, newUserForm));
		}
	}, [
		assignedGroups,
		createGroupOwner,
		handleEnableCheckbox,
		handleGroupChange,
		handleReEnterSSNChange,
		handleGroupOwnerChange,
		handleGroupOwnerDateChange,
		reEnterSSN,
		user?.role
	]);

	// console.log("Create Group Owner", createGroupOwner);
	//console.log("Re Enter SSN", reEnterSSN);

	return (
		<div className="create-createGroupOwner" id="create-createGroupOwner">
			<Suspense fallback={<div />}>
				<LazySnackbarAPI snackbarProps={snackbarAPICallProps} />
			</Suspense>
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleCreateGroupOwner}
					variant="contained"
					disabled={hasCreateClick}
					style={{
						cursor: hasCreateClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Create User</span>
					<span>
						<GroupAddIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<Grid container spacing={1} className="pf-grid-container">
				{userForm &&
					Object.entries(userForm).map(([key, value], index) => {
						return (
							<div key={index}>
								<div
									className="pf-title"
									style={{
										display:
											createGroupOwner.role === ROLES.admin
												? key === "Group Information"
													? "none"
													: ""
												: ""
									}}
								>
									{key}
								</div>
								<Suspense fallback={<div />}>
									<Paper
										className="pf-paper-container"
										elevation={3}
										variant="outlined"
										style={{
											display:
												createGroupOwner.role === ROLES.admin
													? key === "Group Information"
														? "none"
														: ""
													: ""
										}}
									>
										{value.map((field: DynamicFormField, index: number) => {
											return (
												<Grid key={index} item xl={12} lg={12} md={12} sm={12} xs={12}>
													<Grid
														container
														spacing={1}
														className="pf-label"
														style={{
															display:
																createGroupOwner.role === initCapitalize(ROLES.employer)
																	? field.name === "is_employer_chat_support"
																		? "none"
																		: ""
																	: createGroupOwner.role != "ENROLLER"
																	? field.name === "type"
																		? "none"
																		: field.name === "writing_number"
																		? "none"
																		: ""
																	: ""
														}}
													>
														<Grid
															item
															xs={
																field.name === "is_employer_chat_support" ||
																field.name === "is_member_chat_support"
																	? undefined
																	: 12
															}
															sm={
																field.name === "is_employer_chat_support" ||
																field.name === "is_member_chat_support"
																	? undefined
																	: 12
															}
															md={
																field.name === "is_employer_chat_support" ||
																field.name === "is_member_chat_support"
																	? undefined
																	: 3
															}
															lg={
																field.name === "is_employer_chat_support" ||
																field.name === "is_member_chat_support"
																	? undefined
																	: 3
															}
															xl={
																field.name === "is_employer_chat_support" ||
																field.name === "is_member_chat_support"
																	? undefined
																	: 3
															}
														>
															<div
																className={
																	field.name === "first_name" ||
																	field.name === "last_name" ||
																	field.name === "email" ||
																	field.name === "group_number" ||
																	field.name === "role" ||
																	field.name === "type" ||
																	field.name === "writing_number"
																		? // (createGroupOwner.SSN !== "" &&
																		  // 	field.name === "SSN") ||
																		  // (reEnterSSN !== "" &&
																		  // 	field.name === "re_enter_SSN") ||
																		  // (reEnterSSN !== "" && field.name === "SSN") ||
																		  // (createGroupOwner.SSN !== "" &&
																		  // 	field.name === "re_enter_SSN") ||
																		  // (createGroupOwner.hire_date !== "" &&
																		  // 	field.name === "hire_date") ||
																		  // (createGroupOwner.hire_date !== "" &&
																		  // 	field.name === "date_of_birth")
																		  "pf-label-text required"
																		: "pf-label-text"
																}
																id="pf-label-text"
															>
																{field.name === "is_employer_chat_support" ||
																field.name === "is_member_chat_support"
																	? ""
																	: field.label}
															</div>
														</Grid>
														<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
															{field.type === "textfield" ? (
																<TextField
																	className="text-field-input"
																	id="text-field-input"
																	name={field.name}
																	placeholder={field.placeholder}
																	value={
																		field.controlled === false
																			? undefined
																			: field.value
																	}
																	onChange={field.onChange}
																	//onBlur={field.onBlur}
																	onKeyDown={(
																		event: React.KeyboardEvent<HTMLDivElement>
																	) => handleKeyCheck(event)}
																	onPaste={(
																		event: React.ClipboardEvent<HTMLDivElement>
																	) => handlePaste(event)}
																	variant="outlined"
																	inputProps={{
																		onKeyDown:
																			field.name === "ZIP"
																				? handleHyphenInZip
																				: undefined
																	}}
																	InputProps={{
																		readOnly:
																			field.value ===
																			"USA - United States of America"
																				? true
																				: false
																	}}
																	helperText={
																		emailExists && field.name === "email"
																			? "Email exists!"
																			: checkInvalidEmail &&
																			  field.name === "email"
																			? "Please enter a valid email address!"
																			: field.name === "re_enter_SSN"
																			? validation.reEnterSSN
																			: validation.createGroupOwner[field.name]
																	}
																	//style={{ width: "70%", borderRadius: 50 }}
																	//disabled={!isButtonSelected}
																	//disableElevation={!isButtonSelected}
																	style={{
																		//cursor: !isButtonSelected?"not-allowed": "pointer",
																		pointerEvents: "unset",
																		width: "340px",
																		borderRadius: 50
																	}}
																/>
															) : field.type === "select" ? (
																<>
																	<Select
																		id="text-align-options"
																		name={field.name}
																		onChange={field.onChange}
																		//disabled={!isButtonSelected}
																		//disableElevation={!isButtonSelected}
																		style={{
																			//cursor: !isButtonSelected ? "not-allowed" : "pointer",
																			pointerEvents: "unset",
																			minWidth: 180,
																			textAlign: "left",
																			// zIndex: 10000,
																			overflowY: "visible"
																		}}
																		MenuProps={{
																			style: { zIndex: 35960 }
																		}}
																		inputProps={{ "aria-label": "Without label" }}
																	>
																		<MenuItem value="" disabled>
																			Select Value
																		</MenuItem>
																		{field?.options?.map((option: any) => (
																			<MenuItem
																				key={option}
																				value={
																					field.name === "group_number"
																						? option?.group_number
																						: field.name === "type" &&
																						  createGroupOwner.role !=
																								"ENROLLER"
																						? ""
																						: option
																				}
																			>
																				{field.name === "group_number"
																					? option?.name
																					: field.name === "gender"
																					? initCapitalize(option)
																					: field.name === "marital_status"
																					? initCapitalize(option)
																					: field.name === "contact_label"
																					? initCapitalize(option)
																					: option}
																			</MenuItem>
																		))}
																	</Select>
																	{validation &&
																	validation.createGroupOwner[field.name] ? (
																		<div className="details">
																			<span className="select-validation-text2">
																				{
																					validation.createGroupOwner[
																						field.name
																					]
																				}
																			</span>
																		</div>
																	) : null}
																</>
															) : field.type === "date" ? (
																<MuiPickersUtilsProvider utils={DateFnsUtils}>
																	<KeyboardDatePicker
																		className="date-input"
																		id="date-input"
																		inputVariant="outlined"
																		label={field.label}
																		placeholder={field.placeholder}
																		name={field.name}
																		format="MM/dd/yyyy"
																		error={false}
																		value={field.value}
																		onChange={(date: MaterialUiPickersDate) =>
																			field.onChange(date, field.name)
																		}
																		InputProps={{
																			readOnly: true
																		}}
																		InputLabelProps={{
																			shrink: true
																		}}
																		//style={{ width: "340px", borderRadius: 50 }}
																		keyboardIcon={
																			<EventIcon style={{ color: "#7cb342" }} />
																		}
																		KeyboardButtonProps={{
																			"aria-label": "change date"
																		}}
																		// disabled={!isButtonSelected}
																		// disableElevation={!isButtonSelected}
																		style={{
																			// cursor: !isButtonSelected ? "not-allowed" : "pointer",
																			pointerEvents: "unset",
																			width: "340px",
																			borderRadius: 50
																		}}
																		helperText={
																			validation.createGroupOwner[field.name]
																		}
																	/>
																</MuiPickersUtilsProvider>
															) : field.type === "checkbox" ? (
																<>
																	<div className="check-support" id="check-support">
																		<span>
																			<GreenCheckbox
																				onChange={field.onChange}
																				name={field.name}
																				checked={field.value}
																			/>
																		</span>
																		<span
																			className="pf-label-text"
																			id="pf-label-text"
																		>
																			{field.label}
																		</span>
																	</div>
																</>
															) : null}
														</Grid>
													</Grid>
												</Grid>
											);
										})}
									</Paper>
								</Suspense>
							</div>
						);
					})}
			</Grid>
			<div className="pf-action-button-container margin-top-action-button" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleCreateGroupOwner}
					variant="contained"
					disabled={hasCreateClick}
					disableElevation={hasCreateClick}
					style={{
						cursor: hasCreateClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Create User</span>
					<span>
						<GroupAddIcon className="button-icon" />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default CreateGroupOwner;
